// @flow

import React, { Component, Fragment } from "react";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  root: {
    color: theme.palette.primary.main,
    "&$checked": {
      color: theme.palette.primary.main
    }
  },
  checked: {},
  invalid: {
    color: theme.palette.error.main,
    "&$invalidChecked": {
      color: theme.palette.error.main
    }
  },
  invalidChecked: {}
});

type SingleRadioButtonClassesType = {
  root: DictionaryType,
  checked: DictionaryType,
  invalid: DictionaryType,
  invalidChecked: DictionaryType
};

type SingleRadioButtonPropsType = {
  classes: SingleRadioButtonClassesType,
  name: string,
  value: string,
  checkedValue: string,
  onChange: Function,
  label?: string | React$Node,
  isInvalid?: boolean,
  tooltip?: string,
  labelPlace?: string
};

class SingleRadioButton extends Component<SingleRadioButtonPropsType, *> {
  render(): * {
    const classes = this.props.classes;
    const Wrapper = this.props.tooltip ? Tooltip : Fragment;
    const isString =
      typeof this.props.label == "string" || this.props.label instanceof String;

    const RadioNode = (
      <Radio
        name={this.props.name}
        value={this.props.value}
        checked={this.props.checkedValue === this.props.value}
        aria-label={this.props.value}
        classes={{
          root: this.props.isInvalid ? classes.invalid : classes.root,
          checked: this.props.isInvalid
            ? classes.invalidChecked
            : classes.checked
        }}
        onChange={this.props.onChange}
      />
    );

    return (
      <Wrapper {...(this.props.tooltip ? { title: this.props.tooltip } : {})}>
        {this.props.label ? (
          <FormControlLabel
            control={RadioNode}
            label={
              isString ? (
                <Typography variant="subtitle1">{this.props.label}</Typography>
              ) : (
                this.props.label
              )
            }
            labelPlacement={
              this.props.labelPlace ? this.props.labelPlace : "end"
            }
          />
        ) : (
          RadioNode
        )}
      </Wrapper>
    );
  }
}

export default withStyles(styles)(SingleRadioButton);
